<template>
    <RoundButton background="var(--secondary)" class="validate-record-button-container">
        <span class="icon-container"> <i class="icon-check_circle_outline"></i></span>
        <span>
            {{ $t("general.save") }}
        </span>
    </RoundButton>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import colors from "@/styles/colors";
import RoundButton from "@/components/buttons/RoundButton.vue";

export default defineComponent({
    name: "ValidateRecordButton",
    components: {
        RoundButton
    },
    data() {
        return {
            colors
        };
    }
});
</script>
<style scoped>
.validate-record-button-container {
    color: var(--buttonTextColor);
}

.icon-container {
    margin-right: 5px;
    /* because icon seems to not be centered */
    margin-bottom: 2px;
}
</style>
